import { destructureAxiosReq } from '../services/utils';
import qs from 'qs';
import sureAxios from '../services/sureAxios';

/**
 * Get a list of policies.
 *
 * @param {Object} opts The options.
 * @param {String} [opts.clientId] The client id to filter by.
 */
export function getPolicies(opts = {}) {
  const payload = {
    client_id: opts.clientId,
  };
  return destructureAxiosReq(
    sureAxios.get(`/api/management/v1/policies?${qs.stringify(payload)}`)
  );
}

/**
 * Submit a policy number for a policy.
 *
 * @param {Object} opts The options.
 * @param {String} opts.policyId The policy id.
 * @param {String} opts.policyNumber The policy number.
 */
export function submitPolicyNumber({ policyId, policyNumber }) {
  return destructureAxiosReq(
    sureAxios.patch(
      `/api/management/v1/policies/${policyId}?op=submit_policy_number`,
      {
        policy_number: policyNumber,
      }
    )
  );
}

/**
 * Get a single policy.
 *
 * @param {Object} opts The options.
 * @param {String} opts.policyId The policy id.
 */
export function getPolicy({ policyId }) {
  return destructureAxiosReq(
    sureAxios.get(`/api/management/v1/policies/${policyId}`)
  );
}
